import { formatRangeDate } from "@/helper/date-time";
import { Constants } from "@/services/web/api.const";
import { useMemo } from "react";
import { useApi } from "@/services/web/use-api";
import { auth0Config } from "@/configs/auth-config";
import { PaymentHistoryStatistic } from "@/modules/finance/helper/types/payment-statistic.type";
import { READ_ORDERS_SCOPE } from "@/modules/finance/helper/constants/api-payment-history.const";
import { addQueryParametersToUrl } from "@/helper/query-params/add-query-params-to-url.util";

export const usePaymentHistoryStatistic = (cityId: string | undefined | null, startDate: Date, endDate: Date) => {
  const url = useMemo(() => {
    const url = `${Constants.CLIENTS_API_URL}/orders/stats`;

    const { startDate: start_date, endDate: end_date } = formatRangeDate(startDate, endDate);

    let params: Record<string, unknown> = {
      start_date,
      end_date,
    };

    if (cityId) {
      params = {
        ...params,
        cityId,
      };
    }

    return addQueryParametersToUrl(url, params);
  }, [cityId, startDate, endDate]);

  const {
    isLoading: loading,
    error,
    data,
  } = useApi<PaymentHistoryStatistic>(url, {
    method: "GET",
    audience: auth0Config.clientAudiance,
    scope: READ_ORDERS_SCOPE,
  });

  return {
    paymentHistoryStatisticData: data || { data: [], granularity: "" },
    loading,
    error,
  };
};
